import React from 'react';
import { Rocket, Star, Sparkles, GraduationCap } from 'lucide-react';

const About = () => {
  const teamMembers = [
    {
      name: 'Victor',
      role: 'Créateur de jeux',
      icon: <Rocket size={40} />,
      color: '#FF6B35',
      bgColor: '#FFF5F0',
      fontFamily: 'Bangers, cursive'
    },
    {
      name: 'Lise',
      role: 'Experte animations',
      icon: <Star size={40} />,
      color: '#0FBD8C',
      bgColor: '#F0FFFB',
      fontFamily: 'Fredoka One, cursive'
    },
    {
      name: 'Juliette',
      role: 'Designer',
      icon: <Sparkles size={40} />,
      color: '#9966FF',
      bgColor: '#F8F0FF',
      fontFamily: 'Pacifico, cursive'
    },
    {
      name: 'Prof Ms Loïc',
      role: 'Notre super prof',
      icon: <GraduationCap size={40} />,
      color: '#2C3E50',
      bgColor: '#F8F9FA',
      fontFamily: 'Poppins, sans-serif'
    }
  ];

  return (
    <section id="qui-sommes-nous" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="section-title">Qui sommes-nous ?</h2>
        
        <div className="max-w-4xl mx-auto text-center mb-16">
          <p className="text-lg text-[#2C3E50] leading-relaxed">
            Bienvenue sur Scratchflix ! Nous sommes une équipe d'élèves de 5ème primaire de l'École Notre-Dame des Champs à Uccle, Belgique. 
            Passionnés par la programmation et Scratch, nous avons créé cette plateforme dans le cadre de notre projet d'entreprise scolaire. 
            Notre mission : partager notre amour du code et aider d'autres enfants à découvrir le monde merveilleux de la programmation !
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {teamMembers.map((member, index) => (
            <div
              key={index}
              className="team-card"
              style={{ backgroundColor: member.bgColor }}
            >
              <div className="flex justify-center mb-4" style={{ color: member.color }}>
                {member.icon}
              </div>
              <h3
                className="text-4xl font-bold mb-2"
                style={{ color: member.color, fontFamily: member.fontFamily }}
              >
                {member.name}
              </h3>
              <p className="text-lg text-[#6C757D] font-medium">{member.role}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <p className="text-xl text-[#2C3E50] font-semibold">
            Ensemble, nous formons Scratchflix - votre destination pour apprendre Scratch de manière amusante et créative !
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;